import React from 'react'
import { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import Modal from './Modal'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import '../index.css'
import CategoryDAO from '../assets/images/CategoryDAO.png'
import CategoryDeFi from '../assets/images/CategoryDeFi.png'
import CategoryMetaverse from '../assets/images/CategoryMetaverse.png'
import CategoryNFT from '../assets/images/CategoryNFT.png'
import CategorySmartContracts from '../assets/images/CategorySmartContracts.png'
import CategoryTrading from '../assets/images/CategoryTrading.png'
import CategoryBlockchainDev from '../assets/images/CategoryBlockchainDev.png'
import CategoryBasics from '../assets/images/CategoryBasics.png'
import { Button } from './UI'
import { useNavigate, useNavigation } from 'react-router'

const CarouselCategory = () => {
  const [isModalOpen, setIsModalOpen] = useState(false) // State to handle Modal visibility
  const navigate = useNavigate()

  const handleModalOpen = () => {
    setIsModalOpen(true)
  }

  const handleModalClose = () => {
    setIsModalOpen(false)
  }

  const categories = [
    {
      id: 1,
      title: 'Basics',
      description:
        'From understanding blockchain basics to exploring the history of cryptocurrencies, this subject category is the perfect starting point for your blockchain education. Solidify your foundational knowledge with our experienced tutors that will guide you on a comprehensive educational journey',
      buttonText: 'Find your Basics Tutor',
      imgSrc: CategoryBasics,
    },
    {
      id: 2,
      title: 'Metaverse',
      description:
        'Metaverse is an umbrella term for virtual worlds with digital experiences that are constantly evolving. Unlock the potential of virtual worlds, decentralized applications, and immersive digital experiences with APOLO. Master the metaverse to unlock endless opportunities in virtual innovation and creativity.',
      buttonText: 'Find your Metaverse Tutor',
      imgSrc: CategoryMetaverse,
    },
    {
      id: 3,
      title: 'DeFi',
      description:
        'Decentralized Finance (DeFi) is transforming the financial system by enabling a wide array of services, including lending, borrowing, trading, staking, and creating synthetic assets, all powered by decentralization, peer-to-peer networks, and smart contracts. ',
      buttonText: 'Find your DeFi Tutor',
      imgSrc: CategoryDeFi,
    },
    {
      id: 4,
      title: 'Smart Contracts',
      description:
        'Smart Contracts are self-executing agreements coded on a blockchain. With languages like Solidity, you can learn to create these contracts using our collaborative code editor. Discover their vast potential across industries, from automating transactions to revolutionizing business processes.',
      buttonText: 'Find your Smart Contracts Tutor',
      imgSrc: CategorySmartContracts,
    },
    {
      id: 5,
      title: 'NFT',
      description:
        "NFT's (non-fungible token) are unique digital identifiers that cannot be copied. They are recorded on blockchains and offer a new form of ownership authenticity. Discover the endless possiblities of NFTs and intriguing NFT projects that are being developed currently!",
      buttonText: 'Find your NFT Tutor',
      imgSrc: CategoryNFT,
    },
    {
      id: 6,
      title: 'DAO',
      description:
        'Decentralized Autonomous Organizations (DAOs) are reshaping governance by enabling community-driven decision-making and equitable power distribution among stakeholders. Explore how DAOs enhance transparency, foster collaboration, and remove the need for intermediaries.',
      buttonText: 'Find your DAO Tutor',
      imgSrc: CategoryDAO,
    },
    {
      id: 7,
      title: 'Trading',
      description:
        'The trading category equips you with the knowledge  to navigate this dynamic landscape. Learn about technical analysis and chart patterns to identify market trends. Explore different trading strategies, such as scalping, swing trading, long-term investing, market indicators, and risk management.',
      buttonText: 'Find your Trading Tutor',
      imgSrc: CategoryTrading,
    },
    {
      id: 8,
      title: 'Blockchain Development',
      description:
        "Blockchain is a secure, decentralized technology that keeps data safe and unchangeable. It's used for much more than cryptocurrencies, helping to improve areas like finance and supply chains. Learn how blockchain development works and start building solutions for the future.",
      buttonText: 'Find your Blockchain Tutor',
      imgSrc: CategoryBlockchainDev,
    },
  ]

  return (
    <>
      <section className="bg-white min-h-[600px] flex items-center justify-center mb-0">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          slidesPerView={1}
          slidesPerGroup={1}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 14000, disableOnInteraction: false }}
          loop={true}
          centeredSlides={true}
          className="CarouselAboutUs-Swiper  "
        >
          {categories.map((category) => (
            <SwiperSlide key={category.id} className="p-2 ">
              <div className="w-full items gap-10 py-14 mb-14 px-8 !border-gray-300/30 rounded-xl md:w-[860px] mx-auto relative md:justify-center md:flex-row flex bg-[linear-gradient(#fff,#fff)_padding-box, linear-gradient(to_right,#f78430,#e12d2e,#cc154b) border_border-box]     border shadow-[2px_2px_0px_4px_rgba(247,132,48,0.3)] md:shadow-[12px_12px_12px_4px_rgba(247,132,48,0.3)]  flex-col justify-start      ">
                <img
                  src={category.imgSrc}
                  alt={category.title}
                  className="w-60  m-auto  !rounded-2xl md:ml-2 md:mr-5"
                />
                <div className="text-center md:!text-left">
                  <h2 className="text-lg mb-2 font-bold text-center md:!text-left">
                    {category.title}
                  </h2>
                  <p className="text-base  text-justify mb-5 font-normal text-gray-800">
                    {category.description}
                  </p>
                  <Button onClick={() => navigate('/student/register')} className="">
                    {/* {category.buttonText} */}
                    Become a Student
                  </Button>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        {isModalOpen && <Modal onClose={handleModalClose} />}
      </section>
    </>
  )
}

export default CarouselCategory
